import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#46B649",
    d: "m15.6.6-.2-.2c-.5-.5-1.3-.5-1.8 0L5.3 8.5l-3.1-3C1.8 5 .9 5 .4 5.5c-.3.2-.4.5-.4.9 0 .3.1.6.4.9l4.1 4.1c.2.2.5.4.9.4s.7-.1.9-.4l9.1-9.1c.2-.2.4-.6.4-.9-.1-.4-.1-.6-.2-.8"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h15.7v11.7H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }